module.exports = __webpack_public_path__ + "static/media/ic_categories_ticket.5bae4d65.svg";